module.exports = __webpack_public_path__ + "img/full7-min.b69b43cd.png";